import { useCallback, useEffect, useRef, useState } from "react";
import { useBeforeUnload, useBlocker } from "react-router-dom";

const useCartLeaveGuard = ({ when = false } = {}) => {
  const allowNextNavigationRef = useRef(false);
  const blocker = useBlocker(() => {
    if (!when) return false;
    if (allowNextNavigationRef.current) {
      allowNextNavigationRef.current = false;
      return false;
    }
    return true;
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!when) {
      setIsOpen(false);
      if (blocker.state === "blocked") {
        blocker.reset();
      }
      return;
    }

    if (blocker.state === "blocked") {
      setIsOpen(true);
      return;
    }

    if (blocker.state === "unblocked") {
      setIsOpen(false);
    }
  }, [blocker, blocker.state, when]);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!when) return;
        event.preventDefault();
        event.returnValue = "";
      },
      [when],
    ),
  );

  const confirmLeave = useCallback(() => {
    setIsOpen(false);
    blocker.proceed();
  }, [blocker]);

  const cancelLeave = useCallback(() => {
    setIsOpen(false);
    blocker.reset();
  }, [blocker]);

  const allowNextNavigation = useCallback(() => {
    allowNextNavigationRef.current = true;
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    confirmLeave,
    cancelLeave,
    allowNextNavigation,
  };
};

export default useCartLeaveGuard;
